import './ytTooltip.scss'

export default {
    name: 'YtTooltip',
    props: {
        // 文字大小
        size: {
            type: Number,
            default: 12
        },
        // iconfont
        icon: {
            type: String,
            default: ''
        },
        // 提示内容
        content: {
            type: String,
            default: ''
        },
        // 触发方式 'hover' | 'click'
        trigger: {
            type: String,
            default: 'hover'
        },

        // 是否显示三角型
        withArrow: {
            type: Boolean,
            default: true
        },

        // 显示位置 'top' | 'bottom'
        placement: {
            type: String,
            default: 'bottom'
        }
    },

    render() {
        return (
            <el-popover
                placement={this.placement}
                trigger={this.trigger}
                content={this.content}
                popper-class='yt-tooltip'
                visible-arrow={this.withArrow}
            >
                <div slot='reference' class='ytTooltip_wrap'>
                    {
                        this.$slots.default && <i class={`iconfont ${this.icon} mr__xxs`} style={`font-size: ${this.size}px`} />
                    }
                    {/* 默认为文本 */}
                    {this.$slots.default}

                    {/* 非文本 */}
                    {this.$slots.elem}
                </div>
            </el-popover>
        )
    }
}
